require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-ball-state-federal-cu-members-votes-to-merge-with-financial-center.json") })
        }
      }, "path---es-articles-ball-state-federal-cu-members-votes-to-merge-with-financial-center");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-ball-state-federal-cu-members-votes-to-merge-with-financial-center!./.cache/json/es-articles-ball-state-federal-cu-members-votes-to-merge-with-financial-center.json
// module id = 2065
// module chunks = 231608221292675